<template>
  <div class="pay-skeleton" :class="[`sk-${section}`]">
    <template v-if="section === 'content' || section === 'full'">
      <div class="sk-title skeleton skeleton-text" style="width: 160px; height: 20px"></div>
      <div class="sk-cards">
        <div class="sk-card">
          <div class="skeleton skeleton-rect" style="height: 120px"></div>
          <div class="skeleton skeleton-text" style="width: 70%; height: 16px"></div>
          <div class="skeleton skeleton-text" style="width: 40%; height: 14px"></div>
        </div>
        <div class="sk-card">
          <div class="skeleton skeleton-rect" style="height: 120px"></div>
          <div class="skeleton skeleton-text" style="width: 60%; height: 16px"></div>
          <div class="skeleton skeleton-text" style="width: 35%; height: 14px"></div>
        </div>
        <div class="sk-card">
          <div class="skeleton skeleton-rect" style="height: 120px"></div>
          <div class="skeleton skeleton-text" style="width: 80%; height: 16px"></div>
          <div class="skeleton skeleton-text" style="width: 45%; height: 14px"></div>
        </div>
      </div>
    </template>

    <template v-if="section === 'payment' || section === 'full'">
      <div class="sk-payment">
        <div class="sk-methods">
          <div class="skeleton skeleton-rect" style="width: 120px; height: 40px; border-radius: 8px"></div>
          <div class="skeleton skeleton-rect" style="width: 120px; height: 40px; border-radius: 8px"></div>
          <div class="skeleton skeleton-rect" style="width: 120px; height: 40px; border-radius: 8px"></div>
        </div>
        <div class="skeleton skeleton-rect" style="width: 200px; height: 44px; border-radius: 8px"></div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{ section?: 'content' | 'payment' | 'full' }>(), {
  section: 'full'
})
</script>

<style scoped lang="scss">
.pay-skeleton {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.sk-title { margin: 8px 0; }

.sk-cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 992px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 640px) { grid-template-columns: 1fr; }
}

.sk-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: #fff;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

.sk-payment {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: stretch;
  }
}

.sk-methods {
  display: flex;
  gap: 12px;
}

/* Skeleton base */
.skeleton {
  position: relative;
  overflow: hidden;
  background-color: #f2f3f5;
}

.skeleton::after {
  content: '';
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.6) 50%, rgba(255,255,255,0) 100%);
  animation: shimmer 1.2s infinite;
}

@keyframes shimmer {
  100% { transform: translateX(100%); }
}

.skeleton-text { border-radius: 6px; }
.skeleton-rect { border-radius: 10px; }
</style>

